import { useLanguage } from "@/i18n/LanguageContext";
import { Crown, Building2, Factory, Wrench, ClipboardCheck, Zap, Server, Calculator } from "lucide-react";

const roles = [
  { i: Crown, role: "CEO / Owner", wants: "Profit, output, customer delivery, less chaos.", msg: "See where profit is lost and how much more output your existing factory can produce." },
  { i: Building2, role: "COO / Plant Manager", wants: "Control, throughput, delivery, OEE, bottlenecks.", msg: "Run the factory with real-time facts instead of delayed reports." },
  { i: Factory, role: "Production Manager", wants: "Job order execution, shift performance, operator discipline.", msg: "Give every shift clear priorities and track output as it happens." },
  { i: Wrench, role: "Maintenance Manager", wants: "Less unplanned downtime, faster response, machine history.", msg: "Connect downtime with maintenance actions and machine-hour based planning." },
  { i: ClipboardCheck, role: "Quality Manager", wants: "Checks, traceability, nonconformance, accountability.", msg: "Digitize inspections and link quality to orders, batches, operators and machines." },
  { i: Zap, role: "Energy Manager", wants: "Energy efficiency, ISO 50001, kWh per product.", msg: "Track energy losses by machine, order, batch or product — not only by total meter reading." },
  { i: Server, role: "IT / ERP Manager", wants: "Secure integration, reliable architecture, no chaos.", msg: "BEEDIGIT integrates with ERP, APS and BI while keeping shop-floor data structured and secure." },
  { i: Calculator, role: "CFO", wants: "ROI, CAPEX control, measurable improvement.", msg: "Start with a focused scope, prove value, then scale step by step." },
];

export default function RoleBasedValue() {
  const { t } = useLanguage();
  return (
    <section className="py-16 md:py-20 border-t border-border bg-[hsl(var(--section-alt))]">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mb-10">
          <p className="eyebrow mb-3">{t("Role-based value")}</p>
          <h2 className="text-3xl md:text-4xl font-bold mb-3">{t("Built for every factory role.")}</h2>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-3">
          {roles.map((r) => (
            <div key={r.role} className="rounded-lg border border-border bg-card p-4">
              <r.i className="h-5 w-5 text-primary mb-2" />
              <h3 className="font-semibold text-sm mb-1">{t(r.role)}</h3>
              <p className="text-xs text-muted-foreground mb-2"><span className="text-foreground/70">{t("Wants:")}</span> {t(r.wants)}</p>
              <p className="text-xs text-foreground/85">{t(r.msg)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}